import { motion } from "framer-motion";
import { engines } from "./data";

export function SectionHeading({ eyebrow, title, sub }) {
  return (
    <div className="mb-12 max-w-2xl">
      <p className="text-[11px] tracking-[0.28em] text-primary uppercase">{eyebrow}</p>
      <h2 className="mt-3 text-3xl font-semibold tracking-tight text-balance sm:text-4xl">
        {title}
      </h2>
      {sub && <p className="mt-3 text-sm text-muted-foreground sm:text-base">{sub}</p>}
      <div className="gold-rule mt-6 w-40" />
    </div>
  );
}

export function Engines() {
  return (
    <section id="engines" className="relative py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Decision Stack"
          title="Nine engines. One final verdict."
          sub="Every setup passes through the stack. The Risk Engine holds the veto — no engine trades alone."
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {engines.map((e, i) => (
            <motion.article
              key={e.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 3) * 0.08 + Math.floor(i / 3) * 0.06, duration: 0.55 }}
              whileHover={{ rotateX: -3, rotateY: 3 }}
              className={`glass glass-hover grain group relative overflow-hidden rounded-2xl p-6 ${
                "primary" in e && e.primary ? "ring-1 ring-primary/35" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-primary/25 bg-primary/10 text-primary transition-colors group-hover:bg-primary/20">
                  <e.icon className="h-5 w-5" />
                </span>
                <span className="flex items-center gap-2 text-[10px] tracking-[0.2em] text-muted-foreground uppercase">
                  <span className="live-dot" /> Live
                </span>
              </div>
              <h3 className="mt-5 text-lg font-semibold">{e.name}</h3>
              <p className="mt-1 text-xs tracking-[0.16em] text-primary uppercase">{e.tag}</p>
              <p className="mt-3 text-sm text-muted-foreground">{e.detail}</p>
              <div
                className="pointer-events-none absolute -right-16 -bottom-16 h-40 w-40 rounded-full opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-40"
                style={{ background: "var(--gradient-gold)" }}
              />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
